import cookie from 'cookie';
import { RequestOptions } from '../types';
import isBrowser from '../../is-browser';
import { uriParse } from '../utils';

function nextCSRF(options: RequestOptions) {
  const { url, headers } = options;

  const urlObj = uriParse(url);

  // 调用 NextJS 的 API
  if (/^\/n\//.test(urlObj.pathname) && /\/api\//.test(urlObj.pathname)) {
    const cookies = cookie.parse((isBrowser ? document.cookie : headers.cookie) || '');
    if (cookies.n_csrf_token) {
      options.headers['X-CSRF-Token'] = cookies.n_csrf_token;
    }
  }

  return options;
}

export default nextCSRF;
